import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL || "https://backend.mystore.education/api";

// دالة مساعدة للحصول على التوكن
const getAuthToken = () => {
  try {
    const storedUser = JSON.parse(localStorage.getItem("loggedUser"));
    
    let token = storedUser?.token;
    if (!token) {
      token = storedUser?.data?.token;
    }
    if (!token) {
      token = storedUser?.user?.token;
    }
    if (!token) {
      token = storedUser?.result?.token;
    }

    return token;
  } catch (error) {
    console.error("❌ Error getting token:", error);
    return null;
  }
};

// Fetch Sections
export const fetchSections = createAsyncThunk(
  "sections/fetchSections",
  async (page = 1, thunkAPI) => {
    try {
      const token = getAuthToken();

      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await axios.get(
        `${BASE_URL}/dashboard/sections?page=${page}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": "ar",
          },
        }
      );

      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "فشل في تحميل الأقسام";
      return thunkAPI.rejectWithValue(message);
    }
  }
);


// Add Section
export const addSection = createAsyncThunk(

  "sections/addSection",
  async (sectionData, thunkAPI) => {
    try {
      const token = getAuthToken();

      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await axios.post(
        `${BASE_URL}/dashboard/sections`,
        {
          name_en: sectionData.name_en,
          name_ar: sectionData.name_ar,
          grade_id: sectionData.grade_id,
          status: sectionData.status
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept-Language": "ar",
          },
        }
      );

      return {
        message: response.data?.message || "Section added successfully",
        data: response.data?.data || response.data,
        success: true
      };
    } catch (error) {
      const message = error.response?.data?.message || "فشل في إضافة القسم";
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Update Section
export const updateSection = createAsyncThunk(
  "sections/updateSection",
  async ({ id, sectionData }, thunkAPI) => {
    try {
      const token = getAuthToken();

      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await axios.post(
        `${BASE_URL}/dashboard/sections/${id}/update`,
        {
          name_en: sectionData.name_en,
          name_ar: sectionData.name_ar,
          grade_id: sectionData.grade_id,
          status: sectionData.status
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept-Language": "ar",
          },
        }
      );

      return {
        message: response.data?.message || "Section updated successfully",
        data: response.data?.data || response.data,
        success: true
      };
    } catch (error) {
      const message = error.response?.data?.message || "فشل في تحديث القسم";
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Delete Section
export const deleteSection = createAsyncThunk(
  "sections/deleteSection",
  async (id, thunkAPI) => {
    try {
      const token = getAuthToken();

      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await axios.delete(
        `${BASE_URL}/dashboard/sections/${id}/delete`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": "ar",
          },
        }
      );

      return {
        message: response.data?.message || "Section deleted successfully",
        id: id,
        success: true
      };
    } catch (error) {
      const message = error.response?.data?.message || "فشل في حذف القسم";
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const initialState = {
  data: [],
  meta: null,
  loading: false,
  error: null,
  addLoading: false,
  addError: null,
  addSuccessMessage: null,
  updateLoading: false,
  updateError: null,
  updateSuccessMessage: null,
  Loading: false,
  deleteError: null,
  deleteSuccessMessage: null,
};

const sectionSlice = createSlice({
  name: "sections",
  initialState,
  reducers: {
    clearSectionState: (state) => {
      state.error = null;
      state.addError = null;
      state.addSuccessMessage = null;
      state.updateError = null;
      state.updateSuccessMessage = null;
      state.deleteError = null;
      state.deleteSuccessMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Sections
      .addCase(fetchSections.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSections.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data || action.payload;
        state.meta = action.payload.meta || null;
        state.error = null;
      })
      .addCase(fetchSections.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      // Add Section
      .addCase(addSection.pending, (state) => {
        state.addLoading = true;
        state.addError = null;
        state.addSuccessMessage = null;
      })
      .addCase(addSection.fulfilled, (state, action) => {
        state.addLoading = false;
        state.addSuccessMessage = action.payload.message;
        state.addError = null;
        if (action.payload.data) {
          state.data.push(action.payload.data);
        }
      })
      .addCase(addSection.rejected, (state, action) => {
        state.addLoading = false;
        state.addError = action.payload;
        state.addSuccessMessage = null;
      })
      
      // Update Section
      .addCase(updateSection.pending, (state) => {
        state.updateLoading = true;
        state.updateError = null;
        state.updateSuccessMessage = null;
      })
      .addCase(updateSection.fulfilled, (state, action) => {
        state.updateLoading = false;
        state.updateSuccessMessage = action.payload.message;
        state.updateError = null;
        if (action.payload.data) {
          const index = state.data.findIndex(section => section.id === action.payload.data.id);
          if (index !== -1) {
            state.data[index] = action.payload.data;
          }
        }
      })
      .addCase(updateSection.rejected, (state, action) => {
        state.updateLoading = false;
        state.updateError = action.payload;
        state.updateSuccessMessage = null;
      })
      
      // Delete Section
      .addCase(deleteSection.pending, (state) => {
        state.deleteLoading = true;
        state.deleteError = null;
        state.deleteSuccessMessage = null;
      })
      .addCase(deleteSection.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.deleteSuccessMessage = action.payload.message;
        state.deleteError = null;
        state.data = state.data.filter(section => section.id !== action.payload.id);
      })
      .addCase(deleteSection.rejected, (state, action) => {
        state.deleteLoading = false;
        state.deleteError = action.payload;
        state.deleteSuccessMessage = null;
      });
  },
});

export const { clearSectionState } = sectionSlice.actions;
export default sectionSlice.reducer; 